import { buttonVariants } from "@/components/ui/button/button-variants";
import { SettingsContainer } from "@/components/ui/SettingsContainer";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { ArrowLeft, X } from "lucide-react";
import React from "react";

type Props = {
	children: React.ReactNode;
};

export default function SecuritySettingsLayout(props: Props) {
	const { children } = props;
	const matchRoute = useMatchRoute();
	const routeMatch = matchRoute({
		to: "/main/setting/security",
	});

	const isSecurityMainPage = !!routeMatch;

	return (
		<SettingsContainer>
			<div className="mb-8 flex justify-end md:justify-start">
				<Link
					to={isSecurityMainPage ? "/main/setting" : "."}
					className={buttonVariants({
						variant: "ghost",
						size: "compact",
					})}
				>
					<X className="text-textDark md:hidden" />
					<ArrowLeft className="text-textDark hidden md:block" />
				</Link>
			</div>
			{children}
		</SettingsContainer>
	);
}
